import { match } from 'ts-pattern';
import { Experiment, ExperimentType } from '../../../../../domains/campaign';
import { ExperimentState } from '../../../../../graphql';
import { SEND_TIME_TOOLTIP_CONTENT, STO_TOOLTIP_CONTENT } from './constants';

export const formatTime = (timeParts: any) => {
  if (timeParts.length === 3) {
    return `${timeParts[0]}, ${timeParts[1]}, and ${timeParts[2]}`;
  } else if (timeParts.length === 2) {
    return `${timeParts[0]} and ${timeParts[1]}`;
  } else if (timeParts.length === 1) {
    return timeParts[0];
  }
  return null;
};

export const pluralize = (length: any, interval: any) => {
  if (length === 1) {
    return `${length} ${interval}`;
  } else {
    return `${length} ${interval}s`;
  }
};

/**
 * Returns a different tooltip content if the campaign has an experiment.
 * @param experiments
 * @return string (tooltip or an empty string)
 */
export const getTooltipContent = (experiments: Experiment[]) => {
  const experimentType = experiments?.[0]?.experimentType;
  const state = experiments?.[0]?.state;
  const isSTOExperiment = experimentType === ExperimentType.SendTimeOptimization;
  const isSendTimeExperiment = experimentType === ExperimentType.SendTime;
  const isExperimentActiveState = [
    ExperimentState.DRAFT,
    ExperimentState.READY,
    ExperimentState.RUNNING,
    ExperimentState.WINNER_FOUND,
  ].includes(state);

  return match({ isSTOExperiment, isExperimentActiveState, isSendTimeExperiment })
    .with(
      {
        isExperimentActiveState: true,
        isSTOExperiment: true,
      },
      () => STO_TOOLTIP_CONTENT,
    )
    .with(
      {
        isExperimentActiveState: true,
        isSendTimeExperiment: true,
      },
      () => SEND_TIME_TOOLTIP_CONTENT,
    )
    .otherwise(() => '');
};
